import React from 'react'
import ReactDOM from 'react-dom'
import accounting from 'accounting'
import StaticTextComponent from './StaticTextComponent'
import $ from 'jquery'
let config = require('config')

class CurrencyComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let input = ReactDOM.findDOMNode(this.refs.input);
    $(function () {
      $(input).keypress(function (e) {
          if (isNaN(this.value + '' + String.fromCharCode(e.charCode))) return false;
        })
        .on('cut copy paste', function (e) {
          e.preventDefault();
        });
    });
  }

  currenySymbol(currency) {
    return (currency === 'USD') ? config.default.currency_format_usd : config.default.currency_format;
  }

  render() {
    if (this.props.isStatic) {
      return <StaticTextComponent value={accounting.formatMoney(this.props.value, this.currenySymbol(this.props.currency))}/>
    }

    return <input
      ref="input"
      type='text'
      className='form-control'
      value={this.props.value}
      onChange={(event) => {
        this.props.onChange(event)
      }}
    />
  }
}


export default CurrencyComponent;



// WEBPACK FOOTER //
// ./src/components/common/CurrencyComponent.js